import { Game } from './game';
/**
 * Created by karthikeyan.k on 26-11-2018.
 */
export class BetLimit {
  fcg21ornothing: Game;
  fcgbaccarat: Game;
}
